/* Чеки Checkbox (/finance/checkbox). Kept apart from uk.ts/en.ts to keep merges small. */
export const checkboxUk = {
  'nav.checkbox': 'Чеки Checkbox',
  'perm.checkbox.read': 'Чеки Checkbox: чеки, зміни, Z-звіти, обороти ФОП',
  'perm.checkbox.manage': 'Ручне зіставлення чеків Checkbox з оплатами',
  'cb.title': 'Чеки Checkbox',
  'cb.subtitle': 'Фіскальні чеки ПРРО з усіх кас: зіставлення з оплатами Enote, зміни та Z-звіти, обороти ФОП і ротація кас.',
  'cb.tab.receipts': 'Чеки',
  'cb.tab.shifts': 'Зміни й Z-звіти',
  'cb.tab.unmatched': 'Незіставлені',
  'cb.tab.turnover': 'Обороти ФОП',
  'cb.tab.rotation': 'Каси по днях',
  'cb.tab.registers': 'Каси',
  'cb.notConfigured': 'Каси Checkbox ще не підключені',
  'cb.notConfiguredHint': 'Додайте каси на вкладці «Каси»: ключ ліцензії каси та логін/пароль або PIN касира з кабінету Checkbox. Чеки почнуть завантажуватися автоматично.',
  'cb.health': 'Синхронізація',
  'cb.unmatched7d': 'Без оплати за 7 днів: {n}',
  'cb.allRegisters': 'Усі каси',
  'cb.allFops': 'Усі ФОП',
  'cb.allTypes': 'Усі типи',
  'cb.allMatch': 'Усі чеки',
  'cb.search': 'Фіскальний номер, № чека або товар',
  'cb.type.SELL': 'Продаж',
  'cb.type.RETURN': 'Повернення',
  'cb.type.SERVICE_IN': 'Службове внесення',
  'cb.type.SERVICE_OUT': 'Службова видача',
  'cb.match.matched': 'З оплатою',
  'cb.match.unmatched': 'Без оплати',
  'cb.match.ambiguous': 'Кілька схожих оплат',
  'cb.match.fiscal_code': 'Є в Enote',
  'cb.match.auto': 'Зіставлено',
  'cb.match.manual': 'Вручну',
  'cb.match.none': 'Без оплати',
  'cb.col.time': 'Час',
  'cb.col.register': 'Каса',
  'cb.col.fop': 'ФОП',
  'cb.col.fiscal': 'Фіск. номер',
  'cb.col.type': 'Тип',
  'cb.col.total': 'Сума',
  'cb.col.cash': 'Готівка',
  'cb.col.card': 'Картка',
  'cb.col.payment': 'Оплата Enote',
  'cb.totals': '{n} чеків · продажі {sell} · повернення {ret} · без оплати {un}',
  'cb.empty': 'Чеків за період немає',
  'cb.emptyHint': 'Змініть період або фільтри. Якщо каси щойно додані — історія завантажується у фоні.',
  'cb.drawerTitle': 'Чек № {n}',
  'cb.lines': 'Товари й послуги',
  'cb.noLines': 'Рядки чека не завантажені',
  'cb.qty': 'К-сть',
  'cb.price': 'Ціна',
  'cb.payment': 'Оплата в Enote',
  'cb.noPayment': 'Оплату не знайдено',
  'cb.noPaymentHint': 'Немає оплати Enote з такою сумою в межах вікна часу. Прив’яжіть вручну за ID оплати або перевірте, чи оплату проведено в Enote.',
  'cb.fopMismatch': 'ФОП каси ≠ ФОП оплати',
  'cb.openVisit': 'Візит',
  'cb.openJourney': 'Шлях клієнта',
  'cb.shift': 'Зміна № {n}',
  'cb.checkTax': 'Перевірити в ДПС',
  'cb.linkPayment': 'Прив’язати до оплати',
  'cb.paymentId': 'ID оплати (UUID)',
  'cb.link': 'Прив’язати',
  'cb.unlink': 'Відв’язати',
  'cb.release': 'Повернути автозіставлення',
  'cb.linked': 'Збережено',
  'cb.relink': 'Перезіставити період',
  'cb.relinked': 'Зіставлено: {m}, неоднозначних: {a}',
  'cb.shiftsEmpty': 'Змін за період немає',
  'cb.shiftsEmptyHint': 'Зміни й Z-звіти завантажуються кожні 30 хвилин для всіх активних кас.',
  'cb.onlyDiff': 'Лише розбіжності',
  'cb.z': 'Z-звіт',
  'cb.zOpen': 'зміна відкрита',
  'cb.enote': 'Enote',
  'cb.diff': 'Різниця',
  'cb.basis.fop': 'оплати ФОП за час зміни',
  'cb.basis.matched': 'оплати, зіставлені з чеками зміни',
  'cb.receiptsN': 'Чеків: {n}, без оплати: {u}',
  'cb.ok': 'Збігається',
  'cb.unmatchedReceipts': 'Чеки без оплати в Enote',
  'cb.unmatchedPayments': 'Оплати без фіскального чека',
  'cb.allMatched': 'Усі чеки мають оплату',
  'cb.allFiscal': 'Усі оплати готівкою/карткою мають чек',
  'cb.overdue': 'понад 24 год',
  'cb.turnoverYear': 'Рік',
  'cb.limit': 'Ліміт',
  'cb.net': 'Оборот',
  'cb.forecast': 'Прогноз на рік',
  'cb.enoteFiscal': 'Enote (готівка+картка)',
  'cb.noFop': 'Каси без ФОП',
  'cb.minWage': 'Ліміт = мінімальна зарплата {w} × коефіцієнт групи (1 — 167, 2 — 834, 3 — 1167). Мінімальну зарплату змінюють у налаштуваннях конектора.',
  'cb.level.ok': 'У межах',
  'cb.level.warning': 'Понад 80 %',
  'cb.level.danger': 'Ризик перевищення',
  'cb.level.over': 'Перевищено',
  'cb.level.no_limit': 'Група не вказана',
  'cb.turnoverEmpty': 'Обороту ще немає',
  'cb.rotationEmpty': 'Чеків за період немає',
  'cb.first': 'Перший',
  'cb.last': 'Останній',
  'cb.shiftsN': 'Змін',
  'cb.date': 'Дата',
  'cb.slot': 'Слот',
  'cb.slot.day': 'День',
  'cb.slot.evening': 'Вечір',
  'cb.slot.pet_shop': 'Зоомагазин',
  'cb.slot.other': 'Інше',
  'cb.addRegister': 'Додати касу',
  'cb.editRegister': 'Каса Checkbox',
  'cb.registersEmpty': 'Кас ще немає',
  'cb.registersHint': 'Ключ ліцензії: кабінет Checkbox → Каси → каса → «Ключ ліцензії». Касир: Касири → логін і пароль (або PIN для кас типу «Агент»). Ключі й паролі зберігаються зашифровано й більше не показуються.',
  'cb.field.name': 'Назва',
  'cb.field.fop': 'ФОП',
  'cb.field.branch': 'Філія',
  'cb.field.slot': 'Слот ротації',
  'cb.field.auth': 'Вхід касира',
  'cb.auth.password': 'Логін і пароль',
  'cb.auth.pin': 'PIN-код',
  'cb.field.active': 'Активна',
  'cb.field.notes': 'Примітки',
  'cb.field.license': 'Ключ ліцензії каси',
  'cb.field.login': 'Логін касира',
  'cb.field.password': 'Пароль касира',
  'cb.field.pin': 'PIN касира',
  'cb.secretSet': 'збережено',
  'cb.secretKeep': 'Порожньо — залишити збережене',
  'cb.fiscalNumber': 'ФН ПРРО',
  'cb.lastReceipt': 'Останній чек',
  'cb.openShift': 'Зміна відкрита',
  'cb.inactive': 'Неактивна',
  'cb.saved': 'Касу збережено',
}

export const checkboxEn: Record<keyof typeof checkboxUk, string> = {
  'nav.checkbox': 'Checkbox receipts',
  'perm.checkbox.read': 'Checkbox receipts, shifts, Z-reports, ФОП turnover',
  'perm.checkbox.manage': 'Link Checkbox receipts to payments by hand',
  'cb.title': 'Checkbox receipts',
  'cb.subtitle': 'Fiscal receipts of all registers: matching with Enote payments, shifts and Z-reports, ФОП turnover and register rotation.',
  'cb.tab.receipts': 'Receipts',
  'cb.tab.shifts': 'Shifts & Z-reports',
  'cb.tab.unmatched': 'Unmatched',
  'cb.tab.turnover': 'ФОП turnover',
  'cb.tab.rotation': 'Registers by day',
  'cb.tab.registers': 'Registers',
  'cb.notConfigured': 'No Checkbox registers yet',
  'cb.notConfiguredHint': 'Add registers on the «Registers» tab: the register licence key and the cashier login/password or PIN from the Checkbox cabinet. Receipts then load automatically.',
  'cb.health': 'Sync',
  'cb.unmatched7d': 'Without payment in 7 days: {n}',
  'cb.allRegisters': 'All registers',
  'cb.allFops': 'All ФОПи',
  'cb.allTypes': 'All types',
  'cb.allMatch': 'All receipts',
  'cb.search': 'Fiscal number, receipt no. or item',
  'cb.type.SELL': 'Sale',
  'cb.type.RETURN': 'Return',
  'cb.type.SERVICE_IN': 'Cash in',
  'cb.type.SERVICE_OUT': 'Cash out',
  'cb.match.matched': 'With payment',
  'cb.match.unmatched': 'Without payment',
  'cb.match.ambiguous': 'Several similar payments',
  'cb.match.fiscal_code': 'In Enote',
  'cb.match.auto': 'Matched',
  'cb.match.manual': 'By hand',
  'cb.match.none': 'No payment',
  'cb.col.time': 'Time',
  'cb.col.register': 'Register',
  'cb.col.fop': 'ФОП',
  'cb.col.fiscal': 'Fiscal no.',
  'cb.col.type': 'Type',
  'cb.col.total': 'Total',
  'cb.col.cash': 'Cash',
  'cb.col.card': 'Card',
  'cb.col.payment': 'Enote payment',
  'cb.totals': '{n} receipts · sales {sell} · returns {ret} · without payment {un}',
  'cb.empty': 'No receipts in this period',
  'cb.emptyHint': 'Change the period or filters. Registers added just now load their history in the background.',
  'cb.drawerTitle': 'Receipt no. {n}',
  'cb.lines': 'Items and services',
  'cb.noLines': 'Receipt lines not loaded',
  'cb.qty': 'Qty',
  'cb.price': 'Price',
  'cb.payment': 'Enote payment',
  'cb.noPayment': 'No payment found',
  'cb.noPaymentHint': 'No Enote payment with this amount within the time window. Link it by payment ID or check that the payment is posted in Enote.',
  'cb.fopMismatch': 'Register ФОП ≠ payment ФОП',
  'cb.openVisit': 'Visit',
  'cb.openJourney': 'Client journey',
  'cb.shift': 'Shift no. {n}',
  'cb.checkTax': 'Check at the tax service',
  'cb.linkPayment': 'Link to a payment',
  'cb.paymentId': 'Payment ID (UUID)',
  'cb.link': 'Link',
  'cb.unlink': 'Unlink',
  'cb.release': 'Back to automatic matching',
  'cb.linked': 'Saved',
  'cb.relink': 'Re-match the period',
  'cb.relinked': 'Matched: {m}, ambiguous: {a}',
  'cb.shiftsEmpty': 'No shifts in this period',
  'cb.shiftsEmptyHint': 'Shifts and Z-reports load every 30 minutes for all active registers.',
  'cb.onlyDiff': 'Differences only',
  'cb.z': 'Z-report',
  'cb.zOpen': 'shift open',
  'cb.enote': 'Enote',
  'cb.diff': 'Difference',
  'cb.basis.fop': 'ФОП payments during the shift',
  'cb.basis.matched': 'payments matched to the shift receipts',
  'cb.receiptsN': 'Receipts: {n}, without payment: {u}',
  'cb.ok': 'Matches',
  'cb.unmatchedReceipts': 'Receipts without an Enote payment',
  'cb.unmatchedPayments': 'Payments without a fiscal receipt',
  'cb.allMatched': 'Every receipt has a payment',
  'cb.allFiscal': 'Every cash/card payment has a receipt',
  'cb.overdue': 'over 24 h',
  'cb.turnoverYear': 'Year',
  'cb.limit': 'Limit',
  'cb.net': 'Turnover',
  'cb.forecast': 'Year forecast',
  'cb.enoteFiscal': 'Enote (cash+card)',
  'cb.noFop': 'Registers without ФОП',
  'cb.minWage': 'Limit = minimum wage {w} × group factor (1 — 167, 2 — 834, 3 — 1167). Change the minimum wage in the connector settings.',
  'cb.level.ok': 'Within',
  'cb.level.warning': 'Over 80 %',
  'cb.level.danger': 'Risk of exceeding',
  'cb.level.over': 'Exceeded',
  'cb.level.no_limit': 'No tax group',
  'cb.turnoverEmpty': 'No turnover yet',
  'cb.rotationEmpty': 'No receipts in this period',
  'cb.first': 'First',
  'cb.last': 'Last',
  'cb.shiftsN': 'Shifts',
  'cb.date': 'Date',
  'cb.slot': 'Slot',
  'cb.slot.day': 'Day',
  'cb.slot.evening': 'Evening',
  'cb.slot.pet_shop': 'Pet shop',
  'cb.slot.other': 'Other',
  'cb.addRegister': 'Add register',
  'cb.editRegister': 'Checkbox register',
  'cb.registersEmpty': 'No registers yet',
  'cb.registersHint': 'Licence key: Checkbox cabinet → Registers → register → «Licence key». Cashier: Cashiers → login and password (or PIN for «Agent» registers). Keys and passwords are stored encrypted and never shown again.',
  'cb.field.name': 'Name',
  'cb.field.fop': 'ФОП',
  'cb.field.branch': 'Branch',
  'cb.field.slot': 'Rotation slot',
  'cb.field.auth': 'Cashier sign-in',
  'cb.auth.password': 'Login and password',
  'cb.auth.pin': 'PIN code',
  'cb.field.active': 'Active',
  'cb.field.notes': 'Notes',
  'cb.field.license': 'Register licence key',
  'cb.field.login': 'Cashier login',
  'cb.field.password': 'Cashier password',
  'cb.field.pin': 'Cashier PIN',
  'cb.secretSet': 'stored',
  'cb.secretKeep': 'Empty — keep the stored value',
  'cb.fiscalNumber': 'Register fiscal no.',
  'cb.lastReceipt': 'Last receipt',
  'cb.openShift': 'Shift open',
  'cb.inactive': 'Inactive',
  'cb.saved': 'Register saved',
}
